import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CONTROLLERS, ENDPOINTS } from 'src/app/constants';
import {
  CCPaymentTrendReportResponse,
  ExportExcelReqCommand,
  FailedPaymentsReportResponse,
  OverallTrendReportResponse,
  PaymentAnalyticsReportResponse,
  PayNowReportResponse,
  Response,
  SendPaymentLinkReportReqCommand,
  SendPaymentLinkReportResponse,
  TransactionHistoryReportResponse,
  WriteBackRetryReportReqCommand,
  WriteBackRetryReportResponse,
} from 'src/app/models';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentReportService {
  private api: string = CONTROLLERS.TENANTS.PAYMENTREPORT;
  constructor(private apiService: ApiService) {}

  getSendpaymentLinkReportList(
    sendPaymentLinkReportReqCommand: SendPaymentLinkReportReqCommand
  ): Observable<Response<SendPaymentLinkReportResponse>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PAYMENTREPORT.GET_SEND_PAYMENT_LINK_REPORT}`,
      sendPaymentLinkReportReqCommand
    );
  }

  getTransactionHistoryReportList(
    sendPaymentLinkReportReqCommand: SendPaymentLinkReportReqCommand
  ): Observable<Response<TransactionHistoryReportResponse>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PAYMENTREPORT.GET_TRANSACTION_HISTORY_REPORT}`,
      sendPaymentLinkReportReqCommand
    );
  }

  getFailedPaymentsReportList(
    sendPaymentLinkReportReqCommand: SendPaymentLinkReportReqCommand
  ): Observable<Response<FailedPaymentsReportResponse>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PAYMENTREPORT.GET_FAILED_PAYMENTS_REPORT}`,
      sendPaymentLinkReportReqCommand
    );
  }

  getPayNowReportList(
    sendPaymentLinkReportReqCommand: SendPaymentLinkReportReqCommand
  ): Observable<Response<PayNowReportResponse>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PAYMENTREPORT.GET_PAY_NOW_REPORT}`,
      sendPaymentLinkReportReqCommand
    );
  }

  getOverAllTrendsReportList(
    sendPaymentLinkReportReqCommand: SendPaymentLinkReportReqCommand
  ): Observable<Response<OverallTrendReportResponse>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PAYMENTREPORT.GET_OVERALL_TRENDS_REPORT}`,
      sendPaymentLinkReportReqCommand
    );
  }

  getCCPaymentTrendsReportList(
    sendPaymentLinkReportReqCommand: SendPaymentLinkReportReqCommand
  ): Observable<Response<CCPaymentTrendReportResponse>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PAYMENTREPORT.GET_CC_PAYMENT_TRENDS_REPORT}`,
      sendPaymentLinkReportReqCommand
    );
  }

  getPaymentAnalyticsReportList(
    sendPaymentLinkReportReqCommand: SendPaymentLinkReportReqCommand
  ): Observable<Response<PaymentAnalyticsReportResponse>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PAYMENTREPORT.GET_PAYMENT_ANALYTICS_REPORT}`,
      sendPaymentLinkReportReqCommand
    );
  }

  getWriteBackRetryReportList(
    writeBackRetryReportReqCommand: WriteBackRetryReportReqCommand
  ): Observable<Response<WriteBackRetryReportResponse>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PAYMENTREPORT.GET_WRITE_BACK_RETRY_REPORT}`,
      writeBackRetryReportReqCommand
    );
  }
  exportWriteBackRetryReport(
    request: WriteBackRetryReportReqCommand
  ): Observable<Blob> {
    return this.apiService.postBlob(
      `${this.api}/${ENDPOINTS.TENANTS.PAYMENTREPORT.EXPORT_WRITE_BACK_RETRY_REPORT}`,
      request
    );
  }

  exportToExcelTransaction(data:ExportExcelReqCommand) : Observable<Blob>{
    return this.apiService.postBlob(
      `${this.api}/${ENDPOINTS.TENANTS.PAYMENTREPORT.EXPORT_TO_EXCEL_REPORT}`,
      data
    );
  }
}
